export default {
    /*
        myGetter(state){ return state.counter + 1000}
    */
}